function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("Publisher")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('address',[_c('a',{attrs:{"href":"https://neurosonology-bg.com/","target":"_blank"}},[_c('strong',[_vm._v("The Bulgarian Society of Neurosonology and Cerebral Hemodynamics")])]),_vm._v(" "),_c('br'),_c('em',[_vm._v("Chairman of BSNCH: Assoc. Prof. S. Mantarova,")]),_vm._v(" "),_c('br'),_vm._v("Tvardishki prohod 23 str., floor 4, office 12\n    "),_c('br'),_vm._v("1404 Sofia, Bulgaria\n    "),_c('br'),_vm._v("Tel: "),_c('a',{attrs:{"href":"tel:+35929225454"}},[_vm._v("+359 2 9225454")]),_vm._v(" "),_c('br'),_vm._v("Email: "),_c('a',{attrs:{"href":"mailto:steffmant@abv.bg"}},[_vm._v("steffmant@abv.bg")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',[_vm._v("With the support of")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/images/fni_logo_en.png","alt":"FNI"}})])])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/contacts","lang":"en"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }